<template>
    <div>
        <ErrorDisplay/>
        Now redirecting you...
    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";

export default {
    name: "BookingRedirect",
    props: ['urlID'],
    components: {
        ErrorDisplay
    },

    async created() {
        try {
            let res = await this.resolveBookingUrl({urlID: this.urlID});
            console.dir(res);

            if(res.status === 200) {
                let data = res.data;

                if (data.type === 'booking') {
                    const url = new URL(data.origUrl);
                    // Merge incoming query params (UTMs, etc.) into the redirect URL
                    const targetParams = new URLSearchParams(url.search);
                    const incomingParams = new URLSearchParams(window.location.search);
                    for (const [key, value] of incomingParams.entries()) {
                        if (!targetParams.has(key)) {
                            targetParams.set(key, value);
                        }
                    }
                    // Tag with short URL ID so booking page can record which link was used
                    targetParams.set('_sid', this.urlID);
                    const redirectUrl = `${window.location.origin}${url.pathname}?${targetParams.toString()}`;
                    console.log(`Redirecting to booking page: ${redirectUrl}`);
                    window.location.href = redirectUrl;
                    return;
                }
            }
        } catch(err) {
            console.error(err);
        }
    },

    data: () => ({

    }),

    methods: {
        ...mapActions('bookingRedirect', ['resolveBookingUrl']),
    },

    computed: {
        ...mapState({
            loading: state => state.alert.loading,
            loaded: state => state.alert.loaded,
            errored: state => state.alert.errored,
            alertMessage: state => state.alert.message,
        })
    }
}

</script>
